// @flow
import React from 'react';
import { METRICS_LEVEL_DISCOUNTS_DIMENSIONS_CONFIG_DIMENSION_BACKEND_NAMES } from '@src/constants';
import { StaticTable } from '@presentational/StaticTable';
import {
  formatSnakeCaseToUppercaseDisplay,
  getDisplayValueForStringOrArrayByJoiningWithComma,
} from '@src/common-utils/utils';
import { StyledH4 } from '@presentational/headings/StyledH4';
import { Spacer } from '@presentational/spacing/Spacer';

const getHeaderRow = (metricData) => {
  const dimensionNames =
    metricData.dimensionRows[0][
      METRICS_LEVEL_DISCOUNTS_DIMENSIONS_CONFIG_DIMENSION_BACKEND_NAMES
    ] ?? [];
  const dimensionNamesWithFormatting = dimensionNames.map(formatSnakeCaseToUppercaseDisplay);
  dimensionNamesWithFormatting.push('Discount (%)');
  return dimensionNamesWithFormatting;
};

const getDataRows = (metricData) => {
  return metricData.dimensionRows.map((row) => {
    const rowCells = row.dimensionLabels.map((dimLabel) => {
      return getDisplayValueForStringOrArrayByJoiningWithComma(dimLabel);
    });

    // Add the discount cell to the row
    rowCells.push(`${row.discount}%`);
    return rowCells;
  });
};

const renderMetricTable = (metricData) => {
  const headerRow = getHeaderRow(metricData);
  const dataRows = getDataRows(metricData);

  const tableContents = {
    headerRow,
    dataRows,
  };

  const metricLabel = metricData.metricLabel;
  return (
    <div key={metricLabel}>
      <Spacer y={10} />
      <StyledH4 text={`Metric: ${metricLabel}`} />
      <StaticTable tableContents={tableContents} />
    </div>
  );
};

// Build the modal body based on whether user is changing system-generated discount
export const getGlobalDiscountConfirmationModalBody = (
  affectedMetrics,
  newGlobalDiscount,
  isUserChangingSystemGeneratedDiscount
) => {
  // When user is editing a system-generated global discount
  if (isUserChangingSystemGeneratedDiscount) {
    return (
      <>
        If you proceed, then SG discount will no longer apply. Are you sure you want to proceed?
        {affectedMetrics && affectedMetrics.length > 0 && (
          <>
            <Spacer y={20} />
            Also, The following system-generated discounts will be removed as they are lower than
            the new Global Discount ( {newGlobalDiscount}% ):
            {affectedMetrics.map((metricData) => renderMetricTable(metricData))}
            <br />
            Please confirm both the actions!!!!!
          </>
        )}
      </>
    );
  }
  // Original behavior: when user is setting a global discount that affects VBD items
  return (
    <>
      The following system-generated discounts will be removed as they are lower than the new Global
      Discount ( <strong>{newGlobalDiscount}%</strong> ). Do you want to proceed with the change?
      {affectedMetrics.map((metricData) => renderMetricTable(metricData))}
    </>
  );
};

// todo::GDCNBCA Remove duplication in the modal body
